export default __webpack_public_path__ + "static/media/apvs-material-2.2efa1f2e.webp";